import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const FscdCoordinationServices = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              FSCD Coordination Services
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                A vital service for FSCD funded clients, our coordination
                services enable your child to receive the optimal holistic care
                from our therapy team. Our FSCD approved coordinator manages all
                the therapy, aide, and respite services for your child and
                liaisons regularly with the therapy team and your FSCD case
                worker to implement, update and modify learning outcomes
                accordingly while managing all scheduling and FSCD required
                documentation for your child’s holistic therapy program. FSCD
                Coordination Services are government funded.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/fscd.jpeg'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FscdCoordinationServices;
